import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Epic and Workstream',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Change Impacts',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Absence',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'absenceDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'absenceDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'absenceBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'absenceGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'absenceMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'absenceGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'absenceProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'absenceStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'absenceBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'absenceTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'absenceTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Academic Staffing',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Adaptive',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'adaptiveTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Banking & Setttlement',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlementTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Benefits',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'benefitsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'benefitsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'benefitsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'benefitsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'benefitsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'benefitsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'benefitsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'benefitsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'benefitsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'benefitsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'benefitsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Business Assets',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'businessAssetsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Compensation',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'compensationDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'compensationDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'compensationBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'compensationGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'compensationMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'compensationGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'compensationProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'compensationStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'compensationBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'compensationTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'compensationTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Core Financials/FDM',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdmTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Cross-Functional',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctionalTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Customer Accounts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'customerAccountsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Data',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'dataDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'dataDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'dataBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'dataGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'dataMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'dataGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'dataProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'dataStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'dataBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'dataTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'dataTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Effort Reporting',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'effortReportingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Financial Accounting',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'financialAccountingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'General',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'generalDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'generalDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'generalBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'generalGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'generalMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'generalGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'generalProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'generalStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'generalBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'generalTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'generalTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Grants',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'grantsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'grantsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'grantsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'grantsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'grantsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'grantsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'grantsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'grantsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'grantsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'grantsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'grantsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'HCM Core',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'hcmCoreTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Integrations',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'integrationsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'integrationsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'integrationsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'integrationsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'integrationsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'integrationsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'integrationsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'integrationsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'integrationsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'integrationsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'integrationsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Inventory Management',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagementTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Learning',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'learningDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'learningDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'learningBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'learningGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'learningMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'learningGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'learningProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'learningStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'learningBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'learningTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'learningTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Payroll',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'payrollDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'payrollDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'payrollBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'payrollGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'payrollMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'payrollGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'payrollProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'payrollStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'payrollBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'payrollTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'payrollTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Payroll Accounting',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccountingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Procurement',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'procurementDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'procurementDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'procurementBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'procurementGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'procurementMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'procurementGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'procurementProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'procurementStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'procurementBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'procurementTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'procurementTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Recruiting',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'recruitingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'recruitingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'recruitingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'recruitingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'recruitingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'recruitingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'recruitingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'recruitingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'recruitingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'recruitingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'recruitingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Reporting',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'reportingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'reportingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'reportingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'reportingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'reportingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'reportingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'reportingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'reportingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'reportingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'reportingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'reportingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Supplier Accounts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccountsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Talent',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'talentDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'talentDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'talentBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'talentGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'talentMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'talentGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'talentProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'talentStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'talentBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'talentTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'talentTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Time Tracking',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'timeTrackingTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    absenceDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceDesign: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceMemberships: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceStewardship: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceBacklog: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceTesting: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    absenceTraining: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingDesign: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingTesting: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffingTraining: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveDesign: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveMemberships: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveStewardship: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveBacklog: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveTesting: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptiveTraining: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementDesign: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementMemberships: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementStewardship: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementBacklog: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementTesting: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlementTraining: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsDesign: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsMemberships: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsStewardship: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsBacklog: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsTesting: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefitsTraining: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsDesign: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsMemberships: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsStewardship: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsBacklog: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsTesting: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssetsTraining: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationDesign: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationMemberships: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationStewardship: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationBacklog: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationTesting: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensationTraining: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmDesign: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmMemberships: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmStewardship: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmBacklog: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmTesting: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdmTraining: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalDesign: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalMemberships: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalStewardship: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalBacklog: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalTesting: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctionalTraining: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsDesign: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsMemberships: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsStewardship: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsBacklog: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsTesting: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccountsTraining: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataDesign: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMemberships: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataStewardship: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataBacklog: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataTesting: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataTraining: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingDesign: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingTesting: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReportingTraining: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingDesign: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingTesting: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccountingTraining: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalDiscovery: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalDesign: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalBioDemo: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalMemberships: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalStewardship: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalBacklog: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalTesting: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    generalTraining: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsDesign: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsMemberships: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsStewardship: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsBacklog: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsTesting: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grantsTraining: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreDiscovery: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreDesign: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreBioDemo: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreMemberships: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreStewardship: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreBacklog: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreTesting: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCoreTraining: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsDesign: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsMemberships: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsStewardship: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsBacklog: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsTesting: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrationsTraining: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementDesign: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementMemberships: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementStewardship: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementBacklog: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementTesting: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagementTraining: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningDesign: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningMemberships: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningStewardship: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningBacklog: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningTesting: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learningTraining: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollDesign: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollMemberships: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollStewardship: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollBacklog: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollTesting: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollTraining: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingDesign: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingTesting: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccountingTraining: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementDesign: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementMemberships: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementStewardship: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementBacklog: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementTesting: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurementTraining: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingDesign: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingTesting: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruitingTraining: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingDesign: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingTesting: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingTraining: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsDesign: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsMemberships: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsStewardship: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsBacklog: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsTesting: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccountsTraining: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentDesign: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentMemberships: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentStewardship: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentBacklog: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentTesting: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talentTraining: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingDiscovery: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingDesign: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingBioDemo: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingGiftsAndPledges: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingMemberships: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingGivingSocieties: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingProspectResearchAndManagement: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingStewardship: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingBacklog: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingTesting: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTrackingTraining: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
